import { accessRole } from "../../../../helpers/access_role"
import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    TabContent, TabPane, Nav, NavItem, NavLink,
    Button,
    Alert,
    UncontrolledAlert,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap"
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import { AvForm } from "availity-reactstrap-validation"
import {ConfirmAlert} from "../../../../helpers/ui/alert";
import apiResponse from '../../../../../src/services/apiResponse';
import IndexBloc from '../index/Blocs/IndexBloc';
import DataTable from "react-data-table-component"; 

var reformatOptions = function(raw, label, value) {
  // console.log(raw)
  return raw.map(function(data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

const reportType = [
  { value: 1, label: 'JPM Pada Jabatan Masing-masing' },
  { value: 2, label: 'JPM Pada Jabatan Tertentu' }
]
const sortOption = [
  { value: 1, label: 'Tinggi ke rendah' },
  { value: 2, label: 'Rendah ke tinggi' }
]
const columns = [
  {
    name: 'No',
    cell: (row, index) => (index+1),
    grow: 0,
  },
  {
     name: 'Nip',
     selector: 'employee_nip',
     sortable: true,
  },
  {
     name: 'Mana Pegawai',
     selector: 'employee_name',
     sortable: true,
  },
  {
     name: 'Jabatan',
     selector: 'position_name',
     sortable: true,
  },
  {
     name: 'JPM',
     selector: 'assessment_jpm',
     sortable: true,
  },
  ];

class IndexView extends Component {

  indexBloc = new IndexBloc()

    constructor(props) {
      let periode_ = React.createRef();
      let eselon_ = React.createRef();

      super(props)
      this.state = {
        assessment_matrix : this.props.matrixid,
        jpmdatas : [{}],
        eselonOption : [
          {
            echelon_name : "",
            echelon_uuid : ""
          }
        ],
        periodeOption : [
          {
            period_assess_name : "",
            period_assess_uuid : ""
          }
        ],
        positionOption : [
          {
            position_name : "",
            position_uuid : ""
          }
        ],
        dataForm : null,
        stperiode : "",
        steselon : "",
        stmatrixlevel : "",
        modal : false,
        detailmatrix : [{}],
        jenisselected: 1
      }
    }
    loadPeriod = async () => {
      await this.indexBloc.fetchPeriod({})
    }
    loadEselon = async () => {
      await this.indexBloc.fetchEselon({})
    }
    loadPosition = async () => {
      await this.indexBloc.fetchPosition({})
    }
    loadMsMatrix = async () => {
      const query = {
          uuid: this.props.uuid
      }
      // console.log(query)
      await this.indexBloc.fetchMatrix(query)
    }
    loadMsassesment = async (mxlvl) => {
      const query = {
          periode: this.state.stperiode,
          eselon: this.state.steselon,
          matrixlevel: mxlvl,
      }
      // console.log(query)
      await this.indexBloc.fetchMatrixassesmentlist(query)
    }
    click_matrix = (matrix_level) =>{
      // alert(matrix_level)
      let mxlvl = matrix_level;
      this.setState({
        stmatrixlevel: mxlvl,
      });
      this.setState({
        modal: !this.state.modal
      });
      // console.log(this.state.stmatrixlevel)
      this.loadMsassesment(mxlvl)
    }
    toggle = ()=> {
      this.setState({
        modal: !this.state.modal
      });
    }
    handleChange = (event)=> {
      // alert(event.value)
      this.setState({
        jenisselected: event.value
      });
      this.loadPosition()
    }
    submitData = async () => {
      this.setState({
        loading: true
      })
      await this.indexBloc.fetchSearchJpm(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
      let forState = {}
      e.preventDefault()
      // console.log(values)
      // return 

      this.setState({
        dataForm: values,
        stperiode: values.periode,
        // steselon: values.eselon,
        // confirm: true
      })
      // console.log(this.state.stperiode);
      // console.log(this.state.steselon);
      this.submitData();
    }
    
    componentDidMount() {
      this.loadPeriod()
        this.indexBloc.periodChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        
                        this.setState({
                            periodeOption: reformatOptions(
                                response, 
                                'period_assess_name',
                                'period_assess_uuid'
                            )
                        })
                        // console.log('periode')
                        // console.log(this.state.periodeOption)
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
      this.loadEselon()
      this.indexBloc.eselonChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log(response)
                      
                      this.setState({
                        eselonOption: reformatOptions(
                              response, 
                              'echelon_name',
                              'echelon_uuid'
                          )
                      })
                      // console.log('eselon')
                      // console.log(this.state.periodeOption)
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      
      this.indexBloc.positionChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log(response)
                      
                      this.setState({
                        positionOption: reformatOptions(
                              response, 
                              'position_name_tab',
                              'position_uuid'
                          )
                      })
                      // console.log('eselon')
                      // console.log(this.state.periodeOption)
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })
      this.loadMsMatrix()
      this.indexBloc.acMatrixChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      // console.log(response)
                      this.setState({
                          msMatrix : response
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
      })

      this.indexBloc.searchJpmChannel.subscribe((result) => {
        switch (result.status) {
          case apiResponse.COMPLETED:
            if(result.data.status) {
              let response = result.data.response
              // console.log(response)
                    this.setState({
                        jpmdatas : response,
                        loading: false,
                        // success: true
                    })
                }
                break
            case apiResponse.ERROR:
                this.setState({
                    loading: false,
                    success: false
                })
                break
            default:
                break
        }
      })
      this.indexBloc.mxListChannel.subscribe((result) => {
        // console.log(result)
        switch (result.status) {
            case apiResponse.COMPLETED:
                if(result.data.status) {
                    let response = result.data.response
                    // console.log(response)
                    this.setState({
                      detailmatrix : response,
                        loading: false,
                        // success: true
                    })
                }
                break
            case apiResponse.ERROR:
                this.setState({
                    loading: false,
                    success: false
                })
                break
            default:
                break
        }
      })
      
  }
    render() {
      return (
        <Fragment>
          <Card>
            <CardBody className="">
              <CardTitle className="h4 mb-4">
              LAPORAN JPM
              <hr />
              </CardTitle>
              <div className=""  style={{padding:'20px',marginLeft:'50px'}}>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                <Row>
                  <Col sm={2}>
                    <label htmlFor="">Jenis Laporan</label>
                  </Col>
                  <Col sm={3}>
                    <CustomSelect 
                        name="jenislaporan"
                        errorMessage="Pilih Jenis Laporan"
                        placeholder="Pilih Jenis Laporan"
                        options={reportType}
                        isSearchable={false}
                        defaultValue={1}
                        onChange={this.handleChange}
                        // defaultValue={reportType[0].value}
                        // isAvForm={false}
                    />
                  </Col>
                  </Row>
                  <br />
                  {
                    (this.state.jenisselected==2)?
                    <>
                    <Row>
                  <Col sm={2}>
                    <label htmlFor="">Jabatan</label>
                  </Col>
                  <Col sm={3}>
                    <CustomSelect 
                        name="jabatan"
                        errorMessage="Pilih Jabatan"
                        placeholder="Pilih Jabatan"
                        options={this.state.positionOption}
                        // isSearchable={false}
                        // defaultValue={1}
                        defaultValue={this.state.positionOption[0].value}
                        // isAvForm={false}
                    />
                  </Col>
                  </Row>
                  <br />
                    </>
                    :''
                  }
                <Row>
                  <Col sm={2}>
                    <label htmlFor="">Periode Assesment</label>
                  </Col>
                  <Col sm={3}>
                    <CustomSelect 
                        name="periode"
                        errorMessage="Pilih Periode"
                        placeholder="Pilih Periode"
                        options={this.state.periodeOption}
                        defaultValue={this.state.periodeOption[0].value}
                        // isAvForm={false}
                    />
                  </Col>
                  </Row>
                  <br />
                  <Row>
                  <Col sm={2}>
                    <label htmlFor="">Urutan</label>
                  </Col>
                  <Col sm={3}>
                    <CustomSelect 
                        name="urutan"
                        errorMessage="Pilih Urutan"
                        placeholder="Pilih Urutan"
                        options={sortOption}
                        isSearchable={false}
                        defaultValue={1}
                        // isAvForm={false}
                    />
                  </Col>
                  <Col sm={3}><button type="submit" className="btn btn-primary"><i className="uil-search-alt"></i>Cari</button></Col>
                </Row>
                </AvForm>
                <br /> 
                <div style={{border:'solid #f6f6f6'}}>
                  <DataTable title="" columns={columns} data={this.state.jpmdatas} pagination/>
                </div>
              </div>
            </CardBody>
          </Card>
          <ConfirmAlert
              confirmTitle="Konfirmasi!"
              confirmInfo="Apakah anda yakin akan menyimpan data ini?"

              loadingTitle="Mencari data..."
              loadingInfo="Tunggu beberapa saat"

              successTitle="Berhasil!"
              successInfo="Data berhasil disimpan"

              failedTitle="Gagal!"
              failedInfo="Data gagal disimpan"

              showConfirm={this.state.confirm}
              showLoading={this.state.loading}
              showSuccess={this.state.success}
              showFailed={this.state.failed}

              response={this.confirmResponse}
          />
          <Modal isOpen={this.state.modal} size='xl'>
          <ModalHeader>Laporan Assesment
          </ModalHeader>
          <ModalBody>
            <table className="table table-bordered">
              <thead style={{background:'lavender'}}>
                <tr>
                  <th>No.</th>
                  <th>Periode Assesment</th>
                  <th>Nama Pegawai</th>
                  <th>Jabatan</th>
                  <th>Assesor</th>
                  <th>Kinerja Pegawai</th>
                  <th>JPM</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.detailmatrix.map((data,index)=>{
                    return(
                        <tr>
                          <td className="text-center">{(index+1)}</td>
                          <td>{data.period_assess_name}</td>
                          <td>{data.employee_full_name}</td>
                          <td>{data.position_name}</td>
                          <td>{data.assessment_assessor_name}</td>
                          <td>{data.performance_name} ({data.performance_code})</td>
                          <td>{data.assessment_jpm}</td>
                        </tr>
                )

              })

              }
              </tbody>
            </table>
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-default" onClick={()=>this.toggle()}>Tutup</button>
          </ModalFooter>
          </Modal>
        </Fragment>
      )
    }
  }
  export default IndexView